<p class="range">{{ rangeLabel() }}</p>
<div class="controls">
  @if (pageSize() !== null) {
    <app-select
      class="page-size"
      ariaLabel="Rows per page"
      bindLabel="label"
      bindValue="value"
      [options]="sizeOptions()"
      [ngModel]="pageSize()"
      (ngModelChange)="onPageSizeChange($event)"></app-select>
  }
  @if (multiPage()) {
    <nav class="pages" [attr.aria-label]="ariaLabel()">
      <button
        type="button"
        class="page-step"
        aria-label="Previous page"
        [disabled]="info().page <= 1"
        (click)="onPageChange(info().page - 1)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
        </svg>
        <span class="page-step__label">Previous</span>
      </button>
      @for (p of pageNumbers(); track p) {
        <button
          type="button"
          class="page-number"
          [class.page-number--current]="p === info().page"
          [attr.aria-current]="p === info().page ? 'page' : null"
          [attr.aria-label]="'Page ' + p"
          (click)="onPageChange(p)">
          {{ p }}
        </button>
      }
      <span class="page-compact" aria-hidden="true">{{ info().page }} / {{ info().totalPages }}</span>
      <button
        type="button"
        class="page-step"
        aria-label="Next page"
        [disabled]="info().page >= info().totalPages"
        (click)="onPageChange(info().page + 1)">
        <span class="page-step__label">Next</span>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
        </svg>
      </button>
    </nav>
  }
</div>
